module.exports = __webpack_public_path__ + "img/patch-check-fill.d31dc327.svg";